export const setLoading = (state, _) => ({ ...state, loading: true, errors: null });
export const setError = (state, action) => ({ ...state, loading: false, errors: action.payload });
export const keyById = (dataArray) => (
  dataArray.reduce((prev, element) => ({ ...prev, [element.id]: element }), {})
);
